import { render } from "./NavTablet.vue?vue&type=template&id=2c9837a4&scoped=true"
import script from "./NavTablet.vue?vue&type=script&lang=ts"
export * from "./NavTablet.vue?vue&type=script&lang=ts"

import "./NavTablet.vue?vue&type=style&index=0&id=2c9837a4&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-2c9837a4"

export default script